import tw, { styled } from 'twin.macro';
const FormRow = styled.div`
  ${tw`flex flex-col gap-2 lg:flex-row`}
`;

export default FormRow;
